import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';

import { ENV_CONFIG } from '@ps/core-config';

import { Report, ReportRequest } from '../models/report.model';
import {
  DownloadUrlResponseDto,
  RequestReportResponseDto,
  UserActivityReportResponseDto,
  ReportListResponseDto,
} from './dtos/report.dto';
import { ReportMapper } from './mappers/report.mapper';
import { ReportPayloadMapper } from './mappers/report-payload.mapper';

@Injectable({ providedIn: 'root' })
export class ReportApi {
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _httpClient = inject(HttpClient);

  private readonly _baseUrl = `${this._environmentConfig.pureSpectrum.url}/reports`;
  private readonly _reportServiceBaseUrl = `${this._environmentConfig.pureSpectrum.reportServiceUrl}/v1/ps-reports-service`;
  private readonly _mapper = new ReportMapper();
  private readonly _payloadMapper = new ReportPayloadMapper();

  public list(userId: number): Observable<Report[]> {
    return this._httpClient
      .get<ReportListResponseDto>(`${this._reportServiceBaseUrl}/reports`, {
        params: { userId },
      })
      .pipe(map((response) => this._mapper.fromDtoList(response.result)));
  }

  public request(reportRequest: ReportRequest): Observable<string> {
    return this._httpClient
      .post<RequestReportResponseDto>(
        this._baseUrl,
        this._payloadMapper.toPayload(reportRequest),
      )
      .pipe(map((response) => response.msg));
  }

  public downloadUrl(filename: string, type: string): Observable<string> {
    return this._httpClient
      .get<DownloadUrlResponseDto>(`${this._baseUrl}/files/download-url`, {
        params: { fileName: filename, type },
      })
      .pipe(map((downloadResponse) => downloadResponse.url));
  }

  public userActivityReport(): Observable<string> {
    return this._httpClient
      .get<UserActivityReportResponseDto>(`${this._baseUrl}/userLoginReport`)
      .pipe(map((response) => response.fileName));
  }
}
